export default __webpack_public_path__ + "/images/christmas-wrapping-paper.jpg";